import PropTypes from 'prop-types'
import { METHOD_OPTIONS } from '../constants'
import { InfoButton } from 'components/buttons'
import RadioGroup from 'components/forms/radio-group'
import classNames from '../due-date-form.scss'

const { grey, selected } = classNames
const { LAST_PERIOD, CONCEPTION_DATE } = METHOD_OPTIONS

const OptionSelect = ({ handleSelection, currentSelection }) => (
  <RadioGroup className={classNames['option-group']}>
    <InfoButton
      pill
      empty
      className={currentSelection !== LAST_PERIOD ? grey : selected}
      onClick={() => handleSelection(LAST_PERIOD)}
    >
      Last Period
    </InfoButton>
    <InfoButton
      pill
      empty
      className={currentSelection !== CONCEPTION_DATE ? grey : selected}
      onClick={() => handleSelection(CONCEPTION_DATE)}
    >
      Conception Date
    </InfoButton>
  </RadioGroup>
)

OptionSelect.propTypes = {
  handleSelection: PropTypes.func.isRequired,
}

export default OptionSelect
